import { render, staticRenderFns } from "./centered-user.vue?vue&type=template&id=22f7eeed&scoped=true"
import script from "./centered-user.vue?vue&type=script&lang=js"
export * from "./centered-user.vue?vue&type=script&lang=js"
import style0 from "./centered-user.vue?vue&type=style&index=0&id=22f7eeed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f7eeed",
  null
  
)

export default component.exports